import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ChangeNameUserCreateModal from "./ChangeNameUserCreateModal";
import {Icon, Modal} from "antd"
import {updateCreatorName} from "../../../services/api/3dApi";

class UserCreate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            userCreateNew: this.props.userCreate || '',
            isOpen: false,
            isUpdated: false,
            error: '',
            loading: false,
            errorUpdate: ''
        }
    }

    _onOpen = () => {
        this.setState({
            isOpen: true,
            isUpdated: false
        })
    }

    _onClose = () => {
        this.setState({
            isOpen: false,
            isUpdated: false,
            error: '',
            errorUpdate: '',
            userCreateNew: this.props.userCreate || ''
        })
    }

    _handleChangeName = (value) => {
        this.setState({
            userCreateNew: value,
            isUpdated: true
        })
    }

    _onUpdateNewName = async () => {
        this.setState({
            loading: true,
            errorUpdate: ''
        })

        try {
            const {batchId} = this.props
            const {userCreateNew} = this.state

            const {'data': response} = await updateCreatorName(batchId, {creator_name: userCreateNew})

            const {success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    errorUpdate: error
                })
            }

            this.setState({
                loading: false,
            }, () => {
                const {refreshBatchInfo} = this.props

                if (typeof refreshBatchInfo === 'function') {
                    refreshBatchInfo()
                }

                this.setState({
                    isOpen: false
                })

                Modal.success({
                    title: 'Thành công',
                    content: 'Thay đổi người tạo thành công'
                })
            })
        } catch (e) {
            this.setState({
                loading: false,
                errorUpdate: e.message
            })
        }
    }

    render() {
        const {userCreate, status} = this.props
        const {isOpen, userCreateNew, isUpdated, loading, error, errorUpdate} = this.state

        return (
            <div>
                <h6>Người tạo:
                    <strong>{userCreate}</strong>
                    {
                        status !== 'completed' ? <Icon type="edit" theme="twoTone" className='ml-1' onClick={this._onOpen}/> : ''
                    }
                </h6>

                <ChangeNameUserCreateModal
                    loading={loading}
                    error={error}
                    errorUpdate={errorUpdate}
                    userCreate={userCreateNew}
                    isOpen={isOpen}
                    isUpdated={isUpdated}
                    onClose={this._onClose}
                    onChangeName={this._handleChangeName}
                    onUpdateName={this._onUpdateNewName}
                />
            </div>
        )
    }
}

UserCreate.propTypes = {
    userCreate: PropTypes.string,
    status: PropTypes.string
}

export default UserCreate
